import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { LandingComponent } from "./landing/landing.component";
import { CreateRequestComponent } from "./quota/create-request/create-request.component";
import { ApproverReviewComponent } from "./quota/approver-review/approver-review.component";
import { OperatorReviewComponent } from "./quota/operator-review/operator-review.component";
import { RequestStatusComponent } from "./quota/request-status/request-status.component";
import {
  LandingGuard,
  hasAnyRole,
  hasPermissionToViewFfp,
  canAccessCcoTestPage,
} from "./core/landing.guard";
import { AgsAadCallbackComponent } from "@ags/core";
import { SupportInformationComponent } from "./quota/region-information/region-information.component";
import { AdminViewRegionComponent } from "./quota/admin-view/admin-view-region.component";
import { AdminViewAZConfigComponent } from "./quota/admin-view/admin-view-azconfig.component";
import { AdminViewUserRoleComponent } from "./quota/admin-view/admin-view-userrole.component";
import { ApproverAdminComponent } from "./quota/approver-admin/approver-admin.component";
import { AdminViewAutoApprovalComponent } from "./quota/admin-view/admin-view-autoapprovalrule.component";
import { AppRoutingModule as BetAppRoutingModule } from "./bet/app-routing.module";
import { ActiveParentRequestsComponent } from "./quota/incidents-view/error-requests/active-parentrequests.component";
import { IncompleteWorkItemsComponent } from "./quota/incidents-view/incomplete-tickets/incomplete-workitems.component";
import { RequestDetailComponent } from "./quota/request-detail/request-detail.component";
import { ActiveSubrequestsComponent } from "./quota/incidents-view/active-subrequests/active-subrequests.component";
import { AdminViewServiceHandlingComponent } from "./quota/admin-view/admin-view-service-handling.component";
import { AdminViewSubscriptionLimitComponent } from "./quota/admin-view/admin-view-subscription-limit.component";
import { AdminViewTableViewComponent } from "./quota/admin-view/admin-view-table-view.component";
import { AdminViewEmailsViewComponent } from "./quota/admin-view/admin-view-emails-view.component";
import { ParentRequestDetailComponent } from "./quota/parent-request-detail/parent-request-detail.component";
import { PlannedQuotaRequestsComponent } from "./quota/planned-quota-requests/planned-quota-requests.component";
import { HoboSubscriptionAutoApprovalRulesComponent } from "./quota/admin-view/admin-view-hobo-subscription-autoapprovalrule.component";
import { SelfServiceComponent } from "./quota/self-service/self-service.component";
import { RequestsWithTicketsInfoComponent } from "./quota/requests-tickets-info/requestsWithTicketsInfo";
import { PlansApprovableComponent } from "./quota/plans/plans-approvable.component";
import { PlanReviewComponent } from "./quota/plans/plan-review.component";
import { PlanDetailComponent } from "./quota/plans/plan-detail.component";
import { PlanEditorComponent } from "./quota/plans/plan-editor.component";
import { PlanHistoryComponent } from "./quota/plans/plan-history.component";
import { PlansComponent } from "./quota/plans/plans.component";
import { PlansAssignmentComponent } from "./quota/plans/plans-assignment.component";
import { PlansMyRegionalPlansComponent } from "./quota/plans/plan-my-regional-plans.component";
import { PlansSignOffComponent } from "./quota/plans/plans-signoff.component";
import { ServiceTeamUserManagement } from "./shared/service-team-user-management/service-team-user-management.component";
import { PlansRegionalQuotaInformationComponent } from "./quota/plans/plans-regional-quota-information.component";
import { AdminViewRegionalQuotaLimitComponent } from "./quota/admin-view/admin-view-regional-quota.component";
import { PlansAllRegionalPlansComponent } from "./quota/plans/plan-all-regional-plans.component";
import { CreatePlannedQuotaRequestComponent } from "./quota/planned-quota-requests/create-planned-quota-request.component";
import { PlansBindingsComponent } from "./quota/plans/plan-bindings.component";
import { PlansBindingsSearchComponent } from "./quota/plans/plan-bindings-search.component";
import { PlannedQuotaFulfillmentStatusComponent } from "./quota/plans/plan-status.component";
import { PlannedQuotaRequestDetailComponent } from "./quota/planned-quota-request-detail/planned-quota-request-detail.component";
import { PlannedQuotaRegionStatusComponent } from "./quota/plans/plan-region-status.component";
import { PlannedQuotaMyRequestsComponent } from "./quota/planned-quota-requests/planned-quota-my-requests.component";
import { PlansAssignmentServiceOwnerComponent } from "./quota/plans/plans-assignment-service-owner.component";
import { PlansInformationVmSizesComponent } from "./quota/plans-information/plans-information-vm-sizes.component";
import { AdminViewSubscriptionBindingsComponent } from "./quota/admin-view/admin-view-bindings-sub";
import { AdminViewPropertyBindingsComponent } from "./quota/admin-view/admin-view-bindings-prop";
import { AdminViewEdgeZoneComponent } from "./quota/admin-view/admin-view-edgezone.component";
import { AdminViewCapacityOrderViewComponent } from "./quota/admin-view/admin-view-capacity-order-view.component";
import { AdminViewCcoTestComponent } from "./quota/admin-view/admin-view-cco-test.component";
import { PlansRisksComponent } from "./quota/risks/plans-risks.component";
import { AdminViewTeamConfigComponent } from "./quota/admin-view/admin-view-team-config.component";
import { AdminViewBlueprintConfigComponent } from "./quota/admin-view/admin-view-blueprint-config.component";
import { AdminViewAutoApprovalThresholdComponent } from "./quota/admin-view/admin-view-execution-plan-auto-approval-threshold.component";
import { PageNotFoundComponent } from "./shared/page-not-found/page-not-found.component";
import { ArmResourceTypeEnablement } from "./shared/arm-resource-type-details/arm-resource-type-details.component";
import { FfpPlansComponent } from "./quota/ffp/ffp-plans.component";
import { FfpPlanEditorComponent } from "./quota/ffp/ffp-plan-editor.component";
import { FfpPlanHistoryComponent } from "./quota/ffp/ffp-plan-history.component";
import { PfPlansComponent } from "./quota/pf/pf-plans.component";
import { PfPlanEditorComponent } from "./quota/pf/pf-plan-editor.component";
import { PfPlanHistoryComponent } from "./quota/pf/pf-plan-history.component";
import { PfPlansApprovableComponent } from "./quota/pf/pf-plans-approvable.component";
import { PfPlanReviewComponent } from "./quota/pf/pf-plan-review.component";
import { PfFfpGrowthFormulasDashboardComponent } from "./quota/pf/pf-ffp-growth-formulas-dashboard.component";
import { PfAdHocRequestsComponent } from "./quota/pf/pf-ad-hoc-requests.component";
import { PfAdHocRequestsApprovableComponent } from "./quota/pf/pf-ad-hoc-requests-approvable.component";
import { PfRequestCreateComponent } from "./quota/pf/pf-request-create.component";
import { PfRequestDetailsComponent } from "./quota/pf/pf-request-details.component";
import { FfpPlansAssignmentServiceOwnerComponent } from "./quota/ffp/ffp-plans-assignment-service-owner.component";
import { FfpPlanReviewComponent } from "./quota/ffp/ffp-plan-review.component";
import { FfpPlansAssignmentComponent } from "./quota/ffp/ffp-plans-assignment.component";
import { FfpMyRegionalPlansComponent } from "./quota/ffp/ffp-plan-my-regional-plans.component";
import { FfpRegionBuildoutComponent } from "./quota/ffp/ffp-buildout.component";
import { FfpBuildoutPlansComponent } from "./quota/ffp/ffp-buildout-plans.component";
import { CapacitySubOrderDetailComponent } from "./quota/plans/capacity-suborder-detail/capacity-suborder-detail.component";
import { CapacityOrderDetailComponent } from "./quota/plans/capacity-order-detail/capacity-order-detail.component";
import { CapacityOrderDetailV2Component } from "./quota/plans/capacity-order-detail/capacity-order-detail-v2.component";
import { AdminViewManatreeComponent } from "./quota/admin-view/admin-view-manatree";
import { ServiceTeamAppManagement } from "./shared/service-team-app-management/service-team-app-management.component";
import { ServiceTeamTrustedServiceManagement } from "./shared/service-team-trusted-service-management/service-team-trusted-service-management.component";
import { TeamsAttestComponent } from "./quota/self-service/teams-attest.component";
import { AdminViewThirdPartySubscriptionAccessComponent } from "./quota/third-party-subscription-access/admin-view-thirdparty-subscription-access.component";
import { CapacityBlueprintOnboardingComponent } from "./capacity-blueprint/onboard-blueprint.component";
import { CapacityBlueprintAssignmentComponent } from "./capacity-blueprint/assign-blueprint.component";
import { CapacityBlueprintDemandsComponent } from "./capacity-blueprint/demands.component";
import { CapacityBlueprintAssignPslComponent } from "./capacity-blueprint/assign-psl.component";
import { CapacityBlueprintSignoffComponent } from "./capacity-blueprint/signoff.component";
import { CapacityBlueprintDemandDetailsComponent } from "./capacity-blueprint/demand-details.component";
import { CapacityBlueprintDetailsComponent } from "./capacity-blueprint/blueprint-details.component";
import { CapacityBlueprintDemandItemDetailsComponent } from "./capacity-blueprint/demand-item-details.component";

const routes: Routes = [
  ...BetAppRoutingModule.routes,
  ...[
    {
      path: "",
      pathMatch: "full" as const,
      component: LandingComponent,
      canActivate: [LandingGuard],
      data: { title: "Home" },
    },
    {
      path: "home",
      component: HomeComponent,
    },
    {
      path: "admin-view/region",
      component: AdminViewRegionComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Region Config" },
    },
    {
      path: "admin-view/azconfig",
      component: AdminViewAZConfigComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "AZ Config" },
    },
    {
      path: "admin-view/edgezone",
      component: AdminViewEdgeZoneComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "EdgeZone Config" },
    },
    {
      path: "admin-view/userrole",
      component: AdminViewUserRoleComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "User Roles" },
    },
    {
      path: "admin-view/autoapprovalrule",
      component: AdminViewAutoApprovalComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Auto Approval Rules" },
    },
    {
      path: "admin-view/autoapprovalrule-hobo",
      component: HoboSubscriptionAutoApprovalRulesComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Auto Approval Rules for Hobo Subscriptions" },
    },
    {
      path: "admin-view/servicehandling",
      component: AdminViewServiceHandlingComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Service Handling" },
    },
    {
      path: "admin-view/regionalQuota",
      component: AdminViewRegionalQuotaLimitComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Regional Quota" },
    },
    {
      path: "admin-view/subscriptionlimit",
      component: AdminViewSubscriptionLimitComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Subscription Limits" },
    },
    {
      path: "admin-view/table-view",
      component: AdminViewTableViewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsOperator")],
      data: { title: "Edit Tables" },
    },
    {
      path: "admin-view/capacity-order-view",
      component: AdminViewCapacityOrderViewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsOperator")],
      data: { title: "Capacity Order View" },
    },
    {
      path: "admin-view/cco-test",
      component: AdminViewCcoTestComponent,
      canActivate: [LandingGuard, canAccessCcoTestPage],
      data: { title: "CCO Test" },
    },
    {
      path: "admin-view/emails-view",
      component: AdminViewEmailsViewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsOperator")],
      data: { title: "Emails View" },
    },
    {
      path: "admin-view/bindings/subscription",
      component: AdminViewSubscriptionBindingsComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Subscription Bindings" },
    },
    {
      path: "admin-view/bindings/property",
      component: AdminViewPropertyBindingsComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Property Bindings" },
    },
    {
      path: "admin-view/teams/config",
      component: AdminViewTeamConfigComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Team Config" },
    },
    {
      path: "admin-view/blueprints/config",
      component: AdminViewBlueprintConfigComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Blueprint Config" },
    },
    {
      path: "admin-view/execution-plan-auto-approval-threshold",
      component: AdminViewAutoApprovalThresholdComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Auto Approval Threshold" },
    },
    {
      path: "admin-view/manatree",
      component: AdminViewManatreeComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Manatree Config" },
    },
    {
      path: "admin-view/thirdparty-subscription-access",
      component: AdminViewThirdPartySubscriptionAccessComponent,
      canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
      data: { title: "Third Party Customer Access" },
    },
    {
      path: "incidents-view/active-subrequests",
      component: ActiveSubrequestsComponent,
      canActivate: [LandingGuard],
      data: { title: "Active Sub Requests" },
    },
    {
      path: "incidents-view/active-requests",
      component: ActiveParentRequestsComponent,
      canActivate: [LandingGuard],
      data: { title: "Active Parent Requests" },
    },
    {
      path: "incidents-view/incomplete-tickets",
      component: IncompleteWorkItemsComponent,
      canActivate: [LandingGuard],
      data: { title: "Incomplete Workitems" },
    },
    {
      path: "create-request",
      component: CreateRequestComponent,
      canActivate: [LandingGuard],
      data: { title: "New Request" },
    },
    {
      path: "request-status",
      component: RequestStatusComponent,
      canActivate: [LandingGuard],
      data: { title: "My Requests" },
    },
    {
      path: "request-status/:requestId/:ticketId/:region",
      component: RequestStatusComponent,
      canActivate: [LandingGuard],
      data: { title: "My Requests" },
    },
    {
      path: "approver-review",
      component: ApproverReviewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsApprover")],
      data: { title: "Approve Requests" },
    },
    {
      path: "approver-admin",
      component: ApproverAdminComponent,
      canActivate: [LandingGuard, hasAnyRole("IsApproverAdmin")],
      data: { title: "Approver Admin" },
    },
    {
      path: "admin/operator-review",
      component: OperatorReviewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsApprover", "IsOperator")],
      data: { title: "All Requests" },
    },
    {
      path: "admin/operator-review/:requestId/:ticketId/:region",
      component: OperatorReviewComponent,
      canActivate: [LandingGuard, hasAnyRole("IsApprover", "IsOperator")],
      data: { title: "All Requests" },
    },
    {
      path: "self-service/revoke-access-quota",
      component: SelfServiceComponent,
      canActivate: [LandingGuard],
      data: { title: "Self Service" },
    },
    {
      path: "self-service/region-information",
      component: SupportInformationComponent,
      canActivate: [LandingGuard],
      data: { title: "Access & Quota Information Self Service" },
    },
    {
      path: "self-service/vm-sizes",
      component: PlansInformationVmSizesComponent,
      canActivate: [LandingGuard],
      data: { title: "VM Sizes" },
    },
    {
      path: "self-service/arm-resource-type",
      component: ArmResourceTypeEnablement,
      canActivate: [LandingGuard],
      data: { title: "Common Arm Resource Type Requirements" },
    },
    {
      path: "self-service/odqattest",
      component: TeamsAttestComponent,
      canActivate: [LandingGuard],
      data: { title: "Attest for S360 KPI" },
    },

    {
      path: "aad-callback",
      pathMatch: "full" as const,
      component: AgsAadCallbackComponent,
    },
    {
      path: "requests/:parentReqId/sub/:subReqId",
      component: RequestDetailComponent,
      canActivate: [LandingGuard],
      data: { title: "Request Detail" },
    },
    {
      path: "requests/:parentReqId/sub/:subReqId/:ticketId/:region",
      component: RequestDetailComponent,
      canActivate: [LandingGuard],
      data: { title: "Request Detail" },
    },
    {
      path: "requests/:parentReqId",
      component: ParentRequestDetailComponent,
      canActivate: [LandingGuard],
      data: { title: "Request Detail" },
    },
    {
      path: "planned",
      children: [
        {
          path: "my-requests",
          component: PlannedQuotaMyRequestsComponent,
          canActivate: [LandingGuard],
          data: { title: "Planned Quota - My Requests" },
        },
        {
          path: "requests",
          component: PlannedQuotaRequestsComponent,
          canActivate: [LandingGuard],
          data: { title: "Planned Quota Requests" },
        },
        {
          path: "create-request",
          component: CreatePlannedQuotaRequestComponent,
          canActivate: [LandingGuard],
          data: { title: "Create Planned Quota Request" },
        },
      ],
    },
    {
      path: "plans",
      children: [
        {
          path: "all",
          component: PlansComponent,
          canActivate: [LandingGuard],
          data: { title: "Service Blueprints" },
        },
        {
          path: "regional/all",
          component: PlansAllRegionalPlansComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plans" },
        },
        {
          path: "regions",
          component: PlansAssignmentComponent,
          canActivate: [LandingGuard, hasAnyRole("IsOperator")],
          data: { title: "Assign Blueprints to Regions" },
        },
        {
          path: "regional/assign",
          component: PlansAssignmentServiceOwnerComponent,
          canActivate: [LandingGuard],
          data: { title: "Assign Blueprint to Regions" },
        },
        {
          path: "regional/signoff",
          component: PlansSignOffComponent,
          canActivate: [LandingGuard],
          data: { title: "Plan Sign-off" },
        },
        {
          path: "regional/mine",
          component: PlansMyRegionalPlansComponent,
          canActivate: [LandingGuard],
          data: { title: "My Execution Plans" },
        },
        {
          path: "bindings",
          component: PlansBindingsSearchComponent,
          canActivate: [LandingGuard],
          data: { title: "Subscription & Resource Bindings" },
        },
        {
          path: "regions/:region/services/:serviceTreeId/blueprints/:blueprint/status",
          component: PlannedQuotaFulfillmentStatusComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plan Fulfillment Status" },
        },
        {
          path: "region",
          component: PlannedQuotaRegionStatusComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plan Fulfillment Status" },
        },
        {
          path: "regions/:region/status",
          component: PlannedQuotaRegionStatusComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plan Fulfillment Status" },
        },
        {
          path: "plans-risks",
          component: PlansRisksComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint Risks" },
        },
        {
          path: "regional/approvable",
          component: PlansApprovableComponent,
          canActivate: [LandingGuard, hasAnyRole("IsApprover")],
          data: { title: "Approvable Execution Plans" },
        },
        {
          path: "approval-info",
          component: PlansRegionalQuotaInformationComponent,
          canActivate: [LandingGuard],
          data: { title: "Quota Allocation Summary" },
        },
        {
          path: "services/:serviceTreeId/regions/:region/versions/:version/blueprints/:blueprint/review",
          component: PlanReviewComponent,
          canActivate: [LandingGuard, hasAnyRole("IsApprover", "IsOperator")],
          data: { title: "Review and Approve Execution Plans" },
        },
        {
          path: "services/:serviceTreeId/regions/:region/blueprints/:blueprint/review",
          component: PlanReviewComponent,
          canActivate: [LandingGuard, hasAnyRole("IsApprover", "IsOperator")],
          data: { title: "Review and Approve Execution Plans" },
        },
        {
          path: "services/:serviceTreeId/regions/:region/versions/:version/blueprints/:blueprint/detail",
          component: PlanDetailComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plan Detail" },
        },
        {
          path: "services/:serviceTreeId/regions/:region/blueprints/:blueprint/detail",
          component: PlanDetailComponent,
          canActivate: [LandingGuard],
          data: { title: "Execution Plan Detail" },
        },
        {
          path: "services/:serviceTreeId/:name/editor",
          component: PlanEditorComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint Editor" },
        },
        {
          path: "services/:serviceTreeId/:name/editor/:fileName",
          component: PlanEditorComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint Editor" },
        },
        {
          path: "services/:serviceTreeId/editor",
          redirectTo: "services/:serviceTreeId/GA/editor"
        },
        {
          path: "services/:serviceTreeId/:name/versions/:version",
          component: PlanHistoryComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint History" },
        },
        {
          path: "services/:serviceTreeId/versions/:version",
          redirectTo: "services/:serviceTreeId/GA/versions/:version"
        },
        {
          path: "requests/:requestId",
          component: PlannedQuotaRequestDetailComponent,
          canActivate: [LandingGuard],
          data: { title: "Planned Quota Request Detail" },
        },
        {
          path: "services/:serviceTreeId/bindings",
          component: PlansBindingsComponent,
          canActivate: [LandingGuard],
          data: { title: "Subscription & Resource Bindings" },
        },
        {
          path: "capacityOrder/:capacityOrderId",
          component: CapacityOrderDetailComponent,
          canActivate: [LandingGuard],
          data: { title: "Capacity Order Detail" },
        },
        {
          path: "capacityOrder/v2/:capacityOrderId",
          component: CapacityOrderDetailV2Component,
          canActivate: [LandingGuard],
          data: { title: "Capacity Order Detail" },
        },
        {
          path: "capacityOrder/orders/:capacityOrderId/subOrders/:subOrderId",
          component: CapacitySubOrderDetailComponent,
          canActivate: [LandingGuard],
          data: { title: "Capacity SubOrder Detail" },
        },
        {
          path: "**",
          component: PageNotFoundComponent,
          data: { title: "Resource not found" },
        },
      ],
    },
    {
      path: "ffp",
      children: [
        {
          path: "all",
          component: FfpPlansComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "FFP Blueprints" },
        },
        {
          path: "plans/services/:serviceTreeId/types/:type/editor",
          component: FfpPlanEditorComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "FFP Blueprint Editor" },
        },
        {
          path: "plans/services/:serviceTreeId/types/:type/versions/:version",
          component: FfpPlanHistoryComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "FFP Blueprint History" },
        },
        {
          path: "plans/assign",
          component: FfpPlansAssignmentServiceOwnerComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "Assign FFP Blueprint to Project" },
        },
        {
          path: "instances/services/:serviceTreeId/projects/:projectOid/versions/:version/review",
          component: FfpPlanReviewComponent,
          canActivate: [LandingGuard, hasAnyRole("IsFfpAdmin", "IsAdmin", "IsApprover")],
          data: { title: "Review and Approve FFP Instances" },
        },
        {
          path: "plans/assign/admin",
          component: FfpPlansAssignmentComponent,
          canActivate: [LandingGuard, hasAnyRole("IsFfpAdmin", "IsAdmin")],
          data: { title: "Assign FFP Blueprint to Project" },
        },
        {
          path: "instances/mine",
          component: FfpMyRegionalPlansComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "My FFP Instances" },
        },
        {
          path: "buildout",
          component: FfpRegionBuildoutComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "FFP Region Buildout" },
        },
        {
          path: "buildout/projects/:projectOid/plans",
          component: FfpBuildoutPlansComponent,
          canActivate: [LandingGuard, hasPermissionToViewFfp],
          data: { title: "FFP Buildout Plans" },
        },
      ],
    },
    {
      path: "pf",
      children: [
        {
          path: "all",
          component: PfPlansComponent,
          canActivate: [LandingGuard],
          data: { title: "PF Capacity Blueprints" },
        },
        {
          path: "ad-hoc-requests/create",
          component: PfRequestCreateComponent,
          canActivate: [LandingGuard],
          data: { title: "Create Ad Hoc Request" },
        },
        {
          path: "ad-hoc-requests/all",
          component: PfAdHocRequestsComponent,
          canActivate: [LandingGuard],
          data: { title: "Ad Hoc Requests" },
        },
        {
          path: "ad-hoc-requests/approvable",
          component: PfAdHocRequestsApprovableComponent,
          canActivate: [LandingGuard],
          data: { title: "Approve Ad Hoc Requests" },
        },
        {
          path: "ad-hoc-requests",
          redirectTo: "ad-hoc-requests/all",
          pathMatch: "full" as const,
        },
        {
          path: "requests/:id",
          component: PfRequestDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "PF Request Details" },
        },
        {
          path: "services/:serviceTreeId/editor",
          component: PfPlanEditorComponent,
          canActivate: [LandingGuard],
          data: { title: "PF Capacity Blueprint Editor" },
        },
        {
          path: "services/:serviceTreeId/versions/:version",
          component: PfPlanHistoryComponent,
          canActivate: [LandingGuard],
          data: { title: "PF Capacity Blueprint History" },
        },
        {
          path: "approvable",
          component: PfPlansApprovableComponent,
          canActivate: [LandingGuard],
          data: { title: "Approve PF Capacity Blueprints" },
        },
        {
          path: "services/:serviceTreeId/versions/:version/review",
          component: PfPlanReviewComponent,
          canActivate: [LandingGuard],
          data: { title: "Review and Approve PF Capacity Blueprints" },
        },
        {
          path: "dashboards/pf-ffp-growth-formulas",
          component: PfFfpGrowthFormulasDashboardComponent,
          canActivate: [LandingGuard],
          data: { title: "PF FFP Growth Formulas" },
        },
      ],
    },
    {
      path: "capacity",
      children: [
        {
          path: "blueprints",
          component: CapacityBlueprintOnboardingComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprints" },
        },
        {
          path: "blueprints/assign/project",
          component: CapacityBlueprintAssignmentComponent,
          canActivate: [LandingGuard],
          data: { title: "Assign via Project" },
        },
        {
          path: "demands",
          component: CapacityBlueprintDemandsComponent,
          canActivate: [LandingGuard],
          data: { title: "Demands" },
        },
        {
          path: "blueprints/assign/PSL",
          component: CapacityBlueprintAssignPslComponent,
          canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
          data: { title: "Assign via PSL" },
        },
        {
          path: "signoff",
          component: CapacityBlueprintSignoffComponent,
          canActivate: [LandingGuard, hasAnyRole("IsAdmin")],
          data: { title: "Signoff" },
        },
        {
          path: "demand/serviceTreeId/:serviceTreeId/type/:type/name/:name/region/:region",
          component: CapacityBlueprintDemandDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Demand Detail" },
        },
        {
          path: "demand/:demandId",
          component: CapacityBlueprintDemandDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Demand Detail" },
        },
        {
          path: "blueprint/serviceTreeId/:serviceTreeId/type/:type/name/:name",
          component: CapacityBlueprintDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint Detail" },
        },
        {
          path: "blueprint/:id",
          component: CapacityBlueprintDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Blueprint Detail" },
        },
        {
          path: "demand-item/serviceTreeId/:serviceTreeId/type/:type/name/:name/region/:region/resource/:resource",
          component: CapacityBlueprintDemandItemDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Demand Item Detail" },
        },
        {
          path: "demand-item/:id",
          component: CapacityBlueprintDemandItemDetailsComponent,
          canActivate: [LandingGuard],
          data: { title: "Demand Item Detail" },
        },
      ],
    },
    {
      path: "self-service/mine/users",
      component: ServiceTeamUserManagement,
      canActivate: [LandingGuard],
      data: { title: "Manage my service team's users" },
    },
    {
      path: "self-service/mine/apps",
      component: ServiceTeamAppManagement,
      canActivate: [LandingGuard],
      data: { title: "Manage my service team's apps" },
    },
    {
      path: "self-service/mine/trusted-services",
      component: ServiceTeamTrustedServiceManagement,
      canActivate: [LandingGuard],
      data: { title: "Manage my service team's trusted services" },
    },
    {
      path: "requests",
      component: RequestsWithTicketsInfoComponent,
      canActivate: [LandingGuard],
      data: { title: "Requests" },
    },
    {
      path: "404",
      component: PageNotFoundComponent,
      data: { title: "Resource not found" },
    },
    {
      path: "**",
      component: PageNotFoundComponent,
      data: { title: "Resource not found" },
    },
  ],
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
